module.exports = __webpack_public_path__ + "610acf4e031d0ec24ee572ad8eae87b9.pdf";